import { render, staticRenderFns } from "./InputSimple.vue?vue&type=template&id=0b2d35fc&scoped=true"
import script from "./InputSimple.vue?vue&type=script&lang=js"
export * from "./InputSimple.vue?vue&type=script&lang=js"
import style0 from "./InputSimple.vue?vue&type=style&index=0&id=0b2d35fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d35fc",
  null
  
)

export default component.exports